import { useEffect, useRef, useState } from 'react';

import { getBackgroundCSS, getBorderCSS, getColorsCSS, getSpaceCSS, getTypoCSS } from '../../Components/utils/getCSS';
import camelCase from './utils/camelCase';

const Portfolio = ({ attributes, clientId, isTitleEdit = false, children }) => {
	const { categories, portfolios, columns, columnGap, rowGap, background, padding, border, filterBtnTypo, filterBtnColors, filterBtnHoverColors, itemHeight, titleBG, titleTypo, titleColor } = attributes;

	const [itemWidth, setItemWidth] = useState('');
	const pfbColumn = useRef(null);

	const [filterKey, setFilterKey] = useState('*');
	const isotope = useRef();

	useEffect(() => {
		setItemWidth(pfbColumn.current.clientWidth);
	}, [pfbColumn.current, columns, columnGap, rowGap]);

	useEffect(() => {
		const gallerySl = `#gallery-${clientId}`;

		const isoOptions = {
			itemSelector: '.galleryItem',
			masonry: {
				fitWidth: true, // When enabled, you can center the container with CSS.
				columnWidth: itemWidth,
				gutter: columnGap
			},
			stagger: 30,
			transitionDuration: '0.5s'
		}

		isotope.current = itemWidth ? new Isotope(gallerySl, isoOptions) : undefined;

		if (isotope.current) {
			const galleryEl = document.querySelector(gallerySl);
			galleryEl.classList.remove('isotopeNotInit')
		}

		return () => isotope.current?.destroy();
	}, [portfolios?.length, columns, columnGap, rowGap, itemWidth, itemHeight]);

	useEffect(() => {
		isotope.current?.arrange({ filter: filterKey === '*' ? '*' : `.${filterKey}` })
	}, [filterKey]);

	const portfolioSl = `#pfbPortfolio-${clientId} .pfbPortfolio`;
	const filterSl = `${portfolioSl} .filter`;
	const galleryItemSl = `${portfolioSl} .galleryItem`;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${getTypoCSS('', filterBtnTypo)?.googleFontLink}
			${getTypoCSS('', titleTypo)?.googleFontLink}
			${getTypoCSS(`${filterSl} button`, filterBtnTypo)?.styles}
			${getTypoCSS(`${galleryItemSl} figcaption p`, titleTypo)?.styles}

			${portfolioSl}{
				${getBackgroundCSS(background)}
				padding: ${getSpaceCSS(padding)};
				${getBorderCSS(border)}
				box-shadow: 0px 25px 30px -20px rgba(0, 0, 0, 0.2);
			}
			${filterSl} button{
				${getColorsCSS(filterBtnColors)}
			}
			${filterSl} button:hover,
			${filterSl} button.current{
				${getColorsCSS(filterBtnHoverColors)}
			}
			${portfolioSl} .pfbColumnSizer {
				grid-column-gap: ${columnGap}px;
			}
			${portfolioSl} .gallery .galleryItem{
				width: ${itemWidth}px;
				height: ${itemHeight};
				margin-bottom: ${rowGap}px;
			}
			${galleryItemSl} figcaption{
				${getBackgroundCSS(titleBG)}
				${isTitleEdit ? 'opacity: 1;' : ''}
			}
			${galleryItemSl} figcaption p{
				color: ${titleColor};
			}
			`.replace(/\s+/g, ' ')
		}} />

		<div className='pfbPortfolio'>
			<div id={`filter-${clientId}`} className='filter'>
				<button className='current' onClick={() => setFilterKey('*')}>All Categories</button>
				{categories?.map(cat => <button key={camelCase(cat)} onClick={() => setFilterKey(camelCase(cat))}>{cat}</button>)}
			</div>

			<div className={`pfbColumnSizer columns-${columns.desktop} columns-tablet-${columns.tablet} columns-mobile-${columns.mobile}`}>
				<div className='pfbColumn' ref={pfbColumn}></div>
			</div>

			{children}
		</div>
	</>
}
export default Portfolio;